<template>
  <v-app style = 'background: #d2d4d7 !important;'>
    <v-toolbar fixed app flat style = 'box-shadow: 0 4px 20px 0 rgba(86, 89, 102, 0.1); background: #fff !important;'>
      <v-toolbar-title>
        <!--span class = 'headline green--text text--darken-4'>Yet VPN</span!-->
        <span style = 'display: flex; align-items: center; min-height: 64px; cursor: pointer;' class = 'yet_logo'></span>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-menu class = 'main_menu' bottom left transition="slide-y-transition" v-if = '!String($route.name).includes("sign")'>
        <v-sheet v-if = '$store.state.user.photoURL' slot="activator" style = 'background: #f3f4f4; border-radius: 26px;'>
          <v-layout row align-center class = 'ma-2'>
            <v-avatar size = '36px'>
              <img :src='$store.state.user.photoURL'>
            </v-avatar>
            <div class = 'caption ml-2'>{{$store.state.user.displayName.split(' ')[0]}}</div>
            <v-icon class = 'ml-1 mr-0 pa-0'>mdi-menu-down</v-icon>
          </v-layout>
        </v-sheet>
        <v-btn v-else icon small @click='deactivateAuth();$router.push("/signin")'><v-icon small>mdi-logout</v-icon></v-btn>
        <v-layout column>
          <v-card tile flat style = 'background-color: #f3f4f4 !important;'>
            <v-card-text>
              <v-layout d-flex row align-center align-content-center justify-center>
                <v-avatar>
                  <img :src='$store.state.user.photoURL'>
                </v-avatar>
                <v-flex ml-2>
                  <div class = 'font-weight-regular'>{{$store.state.user.displayName}}</div>
                  <div>{{$store.state.user.email}}</div>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
          <v-divider></v-divider>
          <v-card tile flat style = 'background-color: #f3f4f4 !important;'>
            <v-list class='py-0 mt-3 mb-3 mx-3' dense>
              <v-list-tile @click.prevent = 'deactivateAuth();$router.push("/signin")' ripple class = 'red--text text--darken-4' style = 'background-color: #FFEBEE; border-radius: 2px;'>
                <v-list-tile-action class = 'pl-2' @click=''><v-icon color = 'red'>mdi-logout</v-icon></v-list-tile-action>
                <v-list-tile-content><v-list-tile-title class = 'body-2 font-weight-light text-xs-center'>Log Out</v-list-tile-title></v-list-tile-content>
              </v-list-tile>
            </v-list>
          </v-card>
        </v-layout>
      </v-menu>
    </v-toolbar>
    <v-content>
      <v-container fluid fill-height my-0 mx-auto pa-0 :style = '`width:${$vuetify.breakpoint.smAndUp? "100%": "100%"};`'>
        <v-layout column align-center justify-center v-show = 'initialize'>
          <v-progress-circular indeterminate :color = '$store.getters.accentColor' size = '32' width = '1'></v-progress-circular>
        </v-layout>
        <router-view v-show = '!initialize' />
      </v-container>
    </v-content>
    <!--v-footer class = 'py-1 px-3'>
      <div><a href="mailto:support@yetvpn.com" class = 'font-weight-regular' style = 'color: black;'>support@yetvpn.com</a></div>
      <v-spacer></v-spacer>
      <div class = 'font-weight-regular'>YetVPN &copy; {{ new Date().getFullYear() }}</div>
    </v-footer!-->
  </v-app>
</template>

<style>
  @import './assets/fonts/inter/inter.css';

  .main_menu .v-menu__content {
    box-shadow: 0 20px 40px 0 rgba(134, 143, 152, 0.1); 
    border-radius: 10px !important;
  }
  .yet_logo {
    order: 1;
    cursor: pointer;
    height: 100%;
    min-width: 128px;
    background-image: url(./assets/yetvpn.svg);
    background-position: center;
    background-size: contain;
    background-repeat: no-repeat;
  }
</style>

<script>
  import aeng from '@/components/auth_engine'
  import firebase from 'firebase/app'
  import 'firebase/auth'
  import 'firebase/firestore'

  export default {
    name: 'App',
    mixins: [aeng],
    data() {
      return {
        initialize: false
      }
    },
    mounted() {
      this.initialize = true;
      this.initApp();
      firebase.auth().onAuthStateChanged( (user) => {
        this.initialize = false;
        if (user) {
          this.$store.dispatch('setToken', {'user': user}).then( (r) => {
            console.log('await complete');
            if (this.$route.name != 'signup') {
              this.$router.push(this.$route.query.redirect || '/');
              firebase.firestore().collection('users').doc(user.email).get().then( (doc) => {
                if (!doc.exists) {
                  console.log('listener: empty user');
                  this.$store.dispatch('makeAuthInvalid');
                  this.deactivateAuth();
                  this.$router.push('/signin');
                  this.authProgress = false;
                } else {
                  console.log('listener: authorized');
                  this.authProgress = false;
                }
              });
            } else {
              this.$store.dispatch('updateRegistrationInfo', {
                email: this.$store.getters.getUser.email,
                firstname: this.$store.getters.getUser && this.$store.getters.getUser.displayName && this.$store.getters.getUser.displayName.split(' ')[0],
                lastname: this.$store.getters.getUser && this.$store.getters.getUser.displayName && this.$store.getters.getUser.displayName.split(' ')[1]
              });
            }
          });
        } else {
          console.log('listener: unauthorized');
          this.authProgress = false;
          if (!this.$route.name.includes('sign')) {
            console.log('listener: deactivating');
            this.deactivateAuth();
            this.$router.push('/signin');
          }
        }
      });
    }
  }
</script>
